import React, { memo, useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import { Button, CardView, Spacer } from 'design-system';
import { IconRocket } from 'design-system/icons/IconRocket';
import Squircle from 'design-system/Squircle';
import Text from 'design-system/Text';
import useColors from 'hooks/useColors';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import useOnboarding from '../hooks/useOnboarding';
const SetupAutomatedSavingsCard = ({ noMarginTop, noMarginBottom }) => {
    const colors = useColors();
    const navigation = useMainStackNavigation();
    const hasFundedPot = useAppSelector((state) => state.pots.hasFundedPot);
    const hasCompletedOnboardingFunnel = useAppSelector((state) => state.pots.hasCompletedOnboardingFunnel);
    const [onboard] = useOnboarding(true);
    const handlePress = useCallback(() => {
        if (!hasFundedPot && !hasCompletedOnboardingFunnel) {
            onboard();
            return;
        }
        navigation.navigateDeprecated('AutosaveIntro');
    }, [hasCompletedOnboardingFunnel, hasFundedPot, onboard]);
    return (<CardView withPadding noMarginBottom={noMarginBottom} noMarginTop={noMarginTop} testID="setupAutosaveCard">
      <Squircle color={colors.background.dark}>
        <IconRocket colorKey="brand"/>
      </Squircle>
      <Spacer h={16}/>
      <Text Text-16>Autosave</Text>
      <Spacer h={4}/>
      <Text TextThin-14 Secondary>
        {noMarginBottom
            ? 'Make your deposits recurring with Emma Autosave'
            : 'Start saving without thinking with Emma’s automation'}
      </Text>
      <Spacer h={16}/>
      <View style={styles.row}>
        <Button square brandReversed hug title="Start autosave" onPress={handlePress}/>
      </View>
    </CardView>);
};
export default memo(SetupAutomatedSavingsCard);
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
    },
});
